export default "__VITE_ASSET__yq85Y1y3__"